import React from 'react';
import {Link} from 'react-router-dom';

const NavDropDownMenu = ({name,links = [{name:"",linkTo:""}]}) => {

    return(
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" id="navbarDarkDropdownMenuLink" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            {name}
          </a>
          <ul class="dropdown-menu dropdown-menu-dark" aria-labelledby="navbarDarkDropdownMenuLink">
            {links.map((value,index) => (
                <li key={index}><Link to={value.linkTo} className="dropdown-item">{value.name}</Link></li>
            ))}
          </ul>
        </li>
    )
}

export default NavDropDownMenu;